export function LongDateFormat(dateTimeStr) {
  const options = {
    weekday: "long",
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  };

  dateTimeStr = adjustToTimezone(dateTimeStr)
  return toDateWithOptions(dateTimeStr, "pt-BR", options)
}

export function ExtraSmallDateFormat(dateTimeStr, options) {
  const optionsShortWeekday = {
    weekday: "short"
  };

  const optionsShortMonth = {
    month: 'short'
  };

  const optionsDay = {
    day: 'numeric'
  };

  if (options && options.adjustToTimezone) {
    dateTimeStr = adjustToTimezone(dateTimeStr);
  }

  const weekday = capitalizeFirstLetter(toDateWithOptions(dateTimeStr, "pt-BR", optionsShortWeekday).replace('.', ''));
  const day = toDateWithOptions(dateTimeStr, "pt-BR", optionsDay).replace('.', '');
  const month = capitalizeFirstLetter(toDateWithOptions(dateTimeStr, "pt-BR", optionsShortMonth).replace('.', ''));

  return weekday + ' ' + day + '/' + month;
}

function adjustToTimezone(dateTimeStr) {
  return dateTimeStr.replace(' ', 'T') + 'Z';
}

function capitalizeFirstLetter(val) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

function toDateWithOptions(utcDateStr, locale, options) {
  return new Date(utcDateStr).toLocaleString(locale, options);
}
